<div class="row" *ngFor="let channel of Channels">
  <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10 ed-cursor-pointer" (click)="openChannel(channel.id)">
      <h6 class="d-md-flex align-items-center my-auto align-items-md-center">{{channel.channel_title}}</h6>
      <p class="color-grey">{{channel.channel_description}}</p>
      
  </div>
  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
    <div *ngIf="channel.num_unread_messages != 0" class="notifica-messaggi-div"><b>{{channel.num_unread_messages}}</b></div>
  </div>
  <div class="col">
    <hr>
  </div>
</div>

<div class="row">
  <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10 ed-cursor-pointer" (click)="openCategory()">
      <h6 class="d-md-flex align-items-center my-auto">Aree Tematiche</h6>
      <p class="color-grey">Lista delle aree tematiche</p>
  </div>
  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
    <h5 class="d-flex align-items-center my-auto"><i class="fa fa-angle-right color-grey" aria-hidden="true"></i></h5>
  </div>
  <div class="col">
    <hr>
  </div>
</div>

<div class="row">
  <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10 ed-cursor-pointer" (click)="openFavoriteThread()">
      <h6 class="d-md-flex align-items-center my-auto align-items-md-center">Discussioni che stai seguendo</h6>
      <p class="color-grey">Elenco delle discussioni preferite</p>
  </div>
  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
    <h5 class="d-md-flex align-items-center my-auto align-items-md-center"><i class="fa fa-angle-right color-grey" aria-hidden="true"></i></h5>
  </div>
  <div class="col">
    <hr>
  </div>
</div>

<div class="row">
  <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10 ed-cursor-pointer" (click)="openHelpDesk()">
      <h6 class="d-md-flex align-items-center my-auto align-items-md-center">Manuale d'uso</h6>
      <p class="color-grey"></p>
  </div>
  <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
    <h5 class="d-md-flex align-items-center my-auto align-items-md-center"><i class="fa fa-angle-right color-grey" aria-hidden="true"></i></h5>
  </div>
  <div class="col">
    <hr>
  </div>
</div>
